/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var pluralization_en_GB = (function (choice) { return choice === 1 ? 0 : 1; });

var pluralization_es_ES = (function (choice) { return choice === 1 ? 0 : 1; });

var pluralization_ru_RU = (function (choice, choicesLength) {
    /** @example удалить рассылку | удалить рассылки */
    if (choicesLength === 2) {
        return choice === 1 ? 0 : 1;
    }
    /** @example 1 яблоко|2-4 яблока, x2-x4 яблока|0 яблок, x0 яблок, 5-9 яблок, 11-14 яблок */
    var mod100 = choice % 100;
    return mod100 % 10 === 1 && mod100 !== 11
        ? 0
        : (mod100 % 10 >= 2 &&
            mod100 % 10 <= 4 &&
            !(mod100 >= 10 && mod100 < 15)
            ? 1
            : 2);
});

var get = function (messages, path) {
    var i = 0;
    var slice = messages[path[0]];
    while (i < path.length) {
        if (typeof slice === 'string' && i + 1 === path.length) {
            return slice;
        }
        if (typeof slice !== 'object') {
            return undefined;
        }
        slice = slice[path[++i]];
    }
    return slice;
};
var replace = function (message, values) {
    return Object.keys(values).reduce(function (message, key) {
        var pattern = new RegExp("\\{".concat(key, "\\}"), 'g');
        var replacement = String(values[key]);
        return message.replace(pattern, replacement);
    }, message);
};
var compile = function (messages, path, values) {
    if (values === void 0) { values = undefined; }
    var message = get(messages, path);
    if (typeof message === 'string' && values) {
        return replace(message, values);
    }
    return message;
};
var fail = function (message) {
    throw new Error(message);
};
var t = function (locale, messages, path, values) {
    var _a;
    if (values === void 0) { values = undefined; }
    var keys = path.split('.');
    if (locale) {
        var message = compile((_a = messages[locale]) !== null && _a !== void 0 ? _a : {}, keys, values);
        return typeof message !== 'object'
            ? message
            : fail("Translation for \"".concat(locale, ":").concat(path, "\" is not translatable"));
    }
    return undefined;
};
/**
 * @param {string} template Варианты множественных форм, разделенные знаком "|"
 * @param {number} choice Количество, по которому выбираем форму
 * @param {PluralizationRule} rule
 * @return {string} Выбранная форма
 */
var plural = function (template, choice, rule) {
    var forms = template.split('|');
    return forms[rule(choice, forms.length)];
};
var I18n = /** @class */ (function () {
    function I18n(options, parent) {
        if (options === void 0) { options = undefined; }
        if (parent === void 0) { parent = undefined; }
        var _a, _b, _c;
        this.parent = parent;
        this.messages = (_a = options === null || options === void 0 ? void 0 : options.messages) !== null && _a !== void 0 ? _a : {};
        this.computed = (_b = options === null || options === void 0 ? void 0 : options.computed) !== null && _b !== void 0 ? _b : {};
        this.pluralization = __assign({ 'en-GB': pluralization_en_GB, 'es-ES': pluralization_es_ES, 'ru-RU': pluralization_ru_RU }, ((_c = options === null || options === void 0 ? void 0 : options.pluralization) !== null && _c !== void 0 ? _c : {}));
        this.fallback = options === null || options === void 0 ? void 0 : options.fallback;
    }
    I18n.prototype.t = function (locale, path, values) {
        var _this = this;
        var _a, _b;
        if (values === void 0) { values = undefined; }
        try {
            var _t = function (locale) { return t(locale, _this.messages, path, values); };
            return (_b = (_a = _t(locale)) !== null && _a !== void 0 ? _a : _t(this.fallback)) !== null && _b !== void 0 ? _b : fail("Translation for \"".concat(path, "\" does not exists"));
        }
        catch (e) {
            if (this.parent) {
                return this.parent.t(locale, path, values);
            }
            throw e;
        }
    };
    I18n.prototype.tc = function (locale, path, choice, values) {
        if (values === void 0) { values = undefined; }
        return plural(this.t(locale, path, values), choice, this.pluralization[locale]);
    };
    I18n.prototype.compute = function (locale, key, values) {
        var computed = this.computed[key];
        if (computed) {
            return computed(localize(this, locale), values);
        }
        if (this.parent) {
            return this.parent.compute(locale, key, values);
        }
        return fail('Key ' + key + ' is not registered');
    };
    I18n.prototype.extend = function (options) {
        return new I18n(__assign({ pluralization: this.pluralization, fallback: this.fallback }, options), this);
    };
    return I18n;
}());
var localize = function (i18n, locale) { return ({
    t: function (path, values) {
        if (values === void 0) { values = undefined; }
        return i18n.t(locale, path, values);
    },
    tc: function (path, choice, values) {
        if (values === void 0) { values = undefined; }
        return i18n.tc(locale, path, choice, values);
    },
    compute: function (key, values) {
        return i18n.compute(locale, key, values);
    },
}); };

export { I18n as default, localize };
